module.exports = __webpack_public_path__ + "img/store-icon.8c133dbb.svg";